import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLocalInstallation: false,
};

export const centerSlice = createSlice({
 name:'centerSlice',
 initialState: initialState,
 reducers:{
  changeSimulatorCenter:(state, action)=>{
   const previousCenter = state.centers.find(center => center.id === action.payload.previousCenterId);
   previousCenter.simulatorCount --;
   const newCenter = state.centers.find(center => center.id === action.payload.newCenterId);
   newCenter.simulatorCount ++;
  },
  setIsLocalInstallation: (state, action) => {
    state.isLocalInstallation = action.payload
  },
  reset:(state, action) => {
  }
 }
})

export const { changeSimulatorCenter, setIsLocalInstallation, reset} = centerSlice.actions;

export default centerSlice.reducer;